import React, { MutableRefObject, useEffect, useRef, useState } from "react";
import jwtDecode from "jwt-decode";
import Label from "components/Label/Label";
import ButtonPrimary from "shared/Button/ButtonPrimary";
import Input from "shared/Input/Input";
import CommonLayout from "./OwnerMenu";
import { json } from "stream/consumers";
import OwnerMenu from "./OwnerMenu";
import AlertModalMessage from "components/AlertModal/AlertModalMessage";
import AlertErrorMessage from "components/AlertModal/AlertModalMessage";
const OwnerAccountPass = () => {
  const server = process.env.REACT_APP_SERVER_URL;
  const token = localStorage.getItem("token") || "";
  let userId: any;
  let profilId: any;

  const oldPasswordRef: MutableRefObject<HTMLInputElement | null> = useRef(null);
  const newPasswordRef: MutableRefObject<HTMLInputElement | null> = useRef(null);
  const confirmPasswordRef: MutableRefObject<HTMLInputElement | null> = useRef(null);

  const [showModalAlert, setShowModalAlert] = useState(false);
  const [showModal, setShowModal] = useState(false);
  const [error, setError] = useState("");
  const [email, setEmail] = useState("");

  if (token) {
    const decodedToken = jwtDecode(token) as {
      userId: string;
      profilId: string;
    };
    userId = decodedToken.userId;
    profilId = decodedToken.profilId;
  }

  useEffect(() => {
    fetch(`${server}/api/user/${userId}`)
      .then((response) => response.json())
      .then((data) => {
        setEmail(data.email);
      });
  }, []);

  const updatePassword = () => {
    const url = `${server}/api/user/password/`;
    const oldPassword = oldPasswordRef.current?.value;
    const newPassword = newPasswordRef.current?.value;
    const confirmPassword = confirmPasswordRef.current?.value;

    if (newPassword !== confirmPassword) {
      setError("Les nouveaux mots de passe ne correspondent pas.");
      return;
    }

    setError("");
    const requestBody = {
      email,
      newPassword,
      oldPassword,
    };

    fetch(url, {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
      },
      body: JSON.stringify(requestBody),
    })
      .then((response) => {
        if (!response.ok) {
          setShowModalAlert(true);
        }
        return response.json();
      })
      .then((data) => {
        setShowModal(true); // Only set it on success
      })
      .catch((error) => {
        setShowModalAlert(true);
        setError(`Erreur lors de la mise à jour du mot de passe: ${error.message}`);
        console.error(error);
      });
  };

  const handleUpdateClick = () => {
    updatePassword();
  };

  return (
    <div>
      <OwnerMenu>
        <div className="space-y-6 sm:space-y-8">
          <AlertErrorMessage
            open={showModalAlert}
            handleClose={() => setShowModalAlert(false)}
            message={`Erreur lors de la mise à jour du mot de passe. Veuillez réessayer.`}
            alertText="Veuillez réessayer."
            navigateTo="/owner-password"
          />
          <AlertModalMessage
            open={showModal}
            handleClose={() => setShowModal(false)}
            message={`Votre mot de passe a été mis à jour avec succès.`}
            alertText="Mot de passe a été mis à jour."
            navigateTo="/owner"
          />
          <h2 className="text-3xl font-semibold">Mettez à jour votre mot de passe.</h2>
          <div className="border-b w-14 border-neutral-200 dark:border-neutral-700"></div>
          <div className="max-w-xl space-y-6 ">
            <div>
              <Label>Mot de passe actuel</Label>
              <Input type="password" className="mt-1.5" ref={oldPasswordRef} />
            </div>
            <div>
              <Label>Nouveau mot de passe</Label>
              <Input type="password" className="mt-1.5" ref={newPasswordRef} />
            </div>
            <div>
              <Label>Confirmer le mot de passe</Label>
              <Input type="password" className="mt-1.5" ref={confirmPasswordRef} />
            </div>
            {error && <div className="text-red-500">{error}</div>}
            <div className="pt-2">
              <ButtonPrimary onClick={handleUpdateClick}>Mettre à jour</ButtonPrimary>
            </div>
          </div>
        </div>
      </OwnerMenu>
    </div>
  );
};

export default OwnerAccountPass;
